import { render, staticRenderFns } from "./MyReservationDetail.vue?vue&type=template&id=58bc4054&scoped=true&"
import script from "./MyReservationDetail.vue?vue&type=script&lang=js&"
export * from "./MyReservationDetail.vue?vue&type=script&lang=js&"
import style0 from "./MyReservationDetail.vue?vue&type=style&index=0&id=58bc4054&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bc4054",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/workspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VBtn,VCardActions,VContainer,VTextarea})
